import type { ReactNode } from "react";

import PageShell from "./PageShell";

/**
 * The shared frame for the legal documents (/terms, /privacy, /dmca):
 * the site chrome around a left-aligned prose column, with the title
 * and last-updated line up top. Each document supplies its body as
 * h2/p/ul prose and closes with a `.legal__credit` attribution note.
 */
const LegalPage = ({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) => (
  <PageShell>
    <main className="station legal">
      <h1 className="station__name">{title}</h1>
      <p className="legal__updated mono">Last updated: {updated}</p>
      <article className="legal__body">{children}</article>
    </main>
  </PageShell>
);

export default LegalPage;
